import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 30px;
`;

const StyledLogoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 700;
		font-size: 20px;
		color: #ffffff;
	}
`;

export { StyledContainer, StyledLogoContainer };
